module.exports = __webpack_public_path__ + "static/media/xiaomi.8e2b3463.jpg";